import React from 'react'


const ProfileMenu = (props) =>
<svg {...props} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g ><path d="M256 274.1c-75.6 0-137.1-61.5-137.1-137.1S180.4 0 256 0s137.1 61.5 137.1 137.1-61.5 137-137.1 137zm0-253.7c-64.3 0-116.6 52.3-116.6 116.6S191.7 253.7 256 253.7s116.6-52.3 116.6-116.6S320.3 20.4 256 20.4z"/><path d="M493.9 512c-5.6 0-10.2-4.6-10.2-10.2 0-125.5-102.1-227.6-227.6-227.6S28.5 376.3 28.5 501.8c0 5.6-4.6 10.2-10.2 10.2s-10.2-4.6-10.2-10.2c0-66.3 25.8-128.6 72.7-175.4s109.2-72.7 175.4-72.7 128.6 25.8 175.4 72.7 72.7 109.2 72.7 175.4c-.2 5.6-4.8 10.2-10.4 10.2z"/></g></svg>

export default ProfileMenu


// WEBPACK FOOTER //
// ./src/components/_common/_icons/ProfileMenu.js